import dayjs from 'dayjs';
import type { QueryParamConfig } from 'use-query-params';

export const validUnixStringOrNull = (dateString?: string | null) => {
  if (!dateString) return null;

  const date = dayjs.unix(parseInt(dateString));
  if (!date.isValid()) return null;
  return date.toISOString();
};

export const UnixDateParam: QueryParamConfig<string | null> = {
  decode: (decodeValue) => {
    if (Array.isArray(decodeValue)) {
      return decodeValue.length > 0
        ? validUnixStringOrNull(decodeValue[0])
        : null;
    }
    return validUnixStringOrNull(decodeValue);
  },
  encode: (encodeValue) => {
    return encodeValue;
  },
};
